module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-collector-1.9fa1adf9.svg";